import { Identifier } from "../../id";
export class CustomParameterTypeId extends Identifier {
    constructor(id) {
        super("CustomParameterTypeId", id);
    }
}
